/*_________________________________________________APP Configuration File____________________________________________
/*
    -> Contains:         Constants For API
    -> Created_by:       .
    -> Created_on:       .
    -> Contact_email:    .

*/

export class AppGlobal {
  /*  API URL */
  // live
  public readonly live = "https://www.telenorsmartteams.com/DAL/";
  public readonly staging = "https://staging.where.works/DAL/";
  public readonly supportpath = "https://support.syntracx.com/DAL/";
  public readonly livepath =
    window.location.protocol + "//" + window.location.host + "/DAL/"; // local
  public readonly apiUrl =
    window.location.host == "localhost" ||
      window.location.host == "localhost:4200"
      ? "https://relief.syntracx.com/DAL/"
      : this.livepath;

  /*  PROCESSES Login And Log Out*/
  public readonly UPDATE_USER_PROFILE_ADDRESS = "UPDATE_USER_PROFILE_ADDRESS";
  public readonly ADD_USER = "ADD_USER";
  public readonly NEW_ACCOUNT_VERIFICATION = "NEW_ACCOUNT_VERIFICATION";
  public readonly SET_PASSWORD = "SET_PASSWORD";
  public readonly USER_LOGIN = "USER_LOGIN";
  public readonly ADD_ACCOUNT_DELETE_REQUEST = "ADD_ACCOUNT_DELETE_REQUEST";
  
  public readonly USER_LOGOUT = "USER_LOGOUT";
  public readonly FORGET_PASSWORD = "FORGET_PASSWORD";
  public readonly RESET_PASSWORD = "RESET_PASSWORD";
  public readonly CHANGE_PASSWORD = "CHANGE_PASSWORD";
  public readonly LAST_LOGGED_IN = "LAST_LOGGED_IN";
  public readonly CHECK_SESSION_STATUS = "CHECK_SESSION_STATUS";
  public readonly LAST_ACTIVITY_HISTORY_ON_PORTAL =
    "LAST_ACTIVITY_HISTORY_ON_PORTAL";
  /*  PROCESSES Org */
  public readonly ADD_ORG = "ADD_ORG";
  public readonly LIST_ALL_MEMBER_ORG = "LIST_ALL_MEMBER_ORG";
  public readonly EDIT_ORG = "EDIT_ORG";
  public readonly DELETE_ORG = "DELETE_ORG";
  public readonly VIEW_ORG = "VIEW_ORG";
  public readonly ALL_COUNTRIES = "ALL_COUNTRIES";
  public readonly ALL_TIMEZONE = "ALL_TIMEZONE";
  public readonly ALL_INDUSTRIES = "ALL_INDUSTRIES";
  public readonly ADD_ORG_META = "ADD_ORG_META";
  public readonly ADD_ORGANOGRAM = "ADD_ORGANOGRAM";
  public readonly UPDATE_ORGANOGRAM = "UPDATE_ORGANOGRAM";
  public readonly DELETE_ORGANOGRAM = "DELETE_ORGANOGRAM";
  public readonly GET_ORGANOGRAM_LIST = "GET_ORGANOGRAM_LIST";
  public readonly GET_COMPLETE_HIERARCHY_ORGANOGRAM =
    "GET_COMPLETE_HIERARCHY_ORGANOGRAM";
  public readonly ADD_DEPARTMENT = "ADD_DEPARTMENT";
  public readonly UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
  public readonly DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
  public readonly LIST_DEPARTMENT = "LIST_DEPARTMENT";
  public readonly ADD_DESIGNATION = "ADD_DESIGNATION";
  public readonly UPDATE_DESIGNATION = "UPDATE_DESIGNATION";
  public readonly DELETE_DESIGNATION = "DELETE_DESIGNATION";
  public readonly LIST_DESIGNATION = "LIST_DESIGNATION";
  /*  PROCESSES Profile*/
  public readonly VIEW_USER_PROFILE = "VIEW_USER_PROFILE";
  public readonly UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
  /*  PROCESSES Shifts*/
  public readonly ADD_ORG_SHIFT = "ADD_ORG_SHIFT";
  public readonly VIEW_SHIFT = "VIEW_SHIFT";
  public readonly VIEW_ORG_SHIFTS = "VIEW_ORG_SHIFTS";
  public readonly UPDATE_ORG_SHIFT = "UPDATE_ORG_SHIFT";
  public readonly DELETE_ORG_SHIFT = "DELETE_ORG_SHIFT";
  public readonly DETACH_TEAM_SHIFT = "DETACH_TEAM_SHIFT";
  public readonly DETACH_SHIFT = "DETACH_SHIFT";
  public readonly TEAMS_BY_SHIFT_ID = "TEAMS_BY_SHIFT_ID";
  public readonly MEMBERS_BY_SHIFT_ID = "MEMBERS_BY_SHIFT_ID";
  /*  PROCESSES Shifts Breaks*/
  public readonly ADD_BREAK = "ADD_BREAK";
  public readonly VIEW_BREAK = "VIEW_BREAK";
  public readonly VIEW_SHIFT_BREAKS = "VIEW_SHIFT_BREAKS";
  public readonly DELETE_BREAK = "DELETE_BREAK";
  public readonly UPDATE_BREAK = "UPDATE_BREAK";
  // PROCESS NAMES FOR MEMBER
  public readonly GET_MEMBERS_TREE = "GET_MEMBERS_TREE";
  public readonly LIST_ALL_ORG_MEMBERS = "LIST_ALL_ORG_MEMBERS";
  public readonly LIST_CUSTOMERS_LINKED_MEMBERS =
    "LIST_CUSTOMERS_LINKED_MEMBERS";
  public readonly LIST_CUSTOMERS_MEMBERS = "LIST_CUSTOMERS_MEMBERS"
  public readonly LIST_ORG_MEMBERS_BY_ID = "LIST_ORG_MEMBERS_BY_ID";
  // public readonly LIST_CUSTOMERS_MEMBERS = "LIST_CUSTOMERS_MEMBERS";
  public readonly TEAMS_BY_MEMBER_ID = "TEAMS_BY_MEMBER_ID";
  public readonly REMOVE_TEAM_MEMBER = "REMOVE_TEAM_MEMBER";
  public readonly REMOVE_TEAM_MEMBER_NEW = "REMOVE_TEAM_MEMBER_NEW";
  public readonly REMOVE_ORG_MEMBERS_BY_ID = "REMOVE_ORG_MEMBERS_BY_ID";
  public readonly VIEW_ORG_ROLES = "VIEW_ORG_ROLES";
  public readonly UPDATE_ORG_MEMBER = "UPDATE_ORG_MEMBER";
  public readonly SEND_INVITATION = "SEND_INVITATION";
  public readonly ACCEPT_INVITATION = "ACCEPT_INVITATION";
  public readonly REJECT_INVITATION = "REJECT_INVITATION";
  public readonly RESEND_INVITATION = "RESEND_INVITATION";
  public readonly ADD_INVITED_SUBSCRIBER = "ADD_INVITED_SUBSCRIBER";
  public readonly LIST_MEM_INVITATIONS = "LIST_MEM_INVITATIONS";
  public readonly CONTACT_PROC_LIST_PENDING = "CONTACT_PROC_LIST_PENDING";
  public readonly CONTACT_PROC_LIST_ALL = "CONTACT_PROC_LIST_ALL";
  public readonly CONTACT_PROC_APPROVE = "CONTACT_PROC_APPROVE";
  public readonly CONTACT_PROC_DELETE = "CONTACT_PROC_DELETE";
  public readonly CONTACT_PROC_REJECT = "CONTACT_PROC_REJECT";
  public readonly CONTACT_PROC_LIST = "CONTACT_PROC_LIST";
  public readonly CONTACT_PROC_INVITE = "CONTACT_PROC_INVITE";
  public readonly CONTACT_PROC_BY_CONTACT_ID = "CONTACT_PROC_BY_CONTACT_ID";

  public readonly ADD_BULK_MEMBER = "ADD_BULK_MEMBER";
  public readonly LIST_MOBILE_FEATURES = "LIST_MOBILE_FEATURES";

  // public readonly ACCEPT_INVITATION = 'ACCEPT_INVITATION';

  // ----------------------------------
  // PROCESS NAMES FOR TEAMS
  public readonly VIEW_ORG_TEAMS = "VIEW_ORG_TEAMS";
  public readonly UPDATE_TEAM = "UPDATE_TEAM";
  public readonly DELETE_TEAM = "DELETE_TEAM";
  public readonly VIEW_TEAM_MEMBERS = "VIEW_TEAM_MEMBERS";
  public readonly VIEW_TEAM = "VIEW_TEAM";
  public readonly VIEW_VISIT_BY_MEMBER_ID = "VIEW_VISIT_BY_MEMBER_ID";
  public readonly ADD_TEAM = "ADD_TEAM";
  public readonly ADD_TEAM_MEMBER = "ADD_TEAM_MEMBER";
  public readonly APPLY_SHIFT = "APPLY_SHIFT";
  public readonly VIEW_APPLIED_SHIFT = "VIEW_APPLIED_SHIFT";
  public readonly VIEW_CHILD_TEAMS = "VIEW_CHILD_TEAMS";
  public readonly UPDATE_TEAM_MEMBER_ROLE = "UPDATE_TEAM_MEMBER_ROLE";
  public readonly VIEW_TEAMS_TREE_LISTING = "VIEW_TEAMS_TREE_LISTING";

  public readonly VIST_BULK_INSERT = "VIST_BULK_INSERT";
  public readonly VIEW_REPORT_EACH_MEMBER = "VIEW_REPORT_EACH_MEMBER";
  public readonly LIST_ORG_DESIGNATIONS = "LIST_ORG_DESIGNATIONS";
  // ----------------------------------
  // PROCESS NAMES FOR DASHBOARD TEAM LOCATIONS
  public readonly UL_PROC_GET_LAST_LOC_BY_TEAMID =
    "UL_PROC_GET_LAST_LOC_BY_TEAMID";
  // public readonly VIEW_ORG_TEAMS = 'VIEW_ORG_TEAMS';
  public readonly GET_USER_CURRENT_TIME = "GET_USER_CURRENT_TIME";
  public readonly ALL_TEAM_MEMBERS = "ALL_TEAM_MEMBERS";
  public readonly UL_PROC_GET_LAST_LOC_BY_ORGID =
    "UL_PROC_GET_LAST_LOC_BY_ORGID";
  // ------------------------------------------

  // PROCESS NAMES FOR Locaton
  public readonly GET_MEMBER_BY_SUB_ID = "GET_MEMBER_BY_SUB_ID";
  public readonly LOC_PROC_SET_LOC_BY_MEMID = "LOC_PROC_SET_LOC_BY_MEMID";
  public readonly LOC_PROC_GET_LOC_BY_ORGID = "LOC_PROC_GET_LOC_BY_ORGID";
  public readonly LOC_PROC_DELETE_LOC_BY_LOCID = "LOC_PROC_DELETE_LOC_BY_LOCID";
  public readonly LOC_PROC_GET_LOC_BY_LOCID = "LOC_PROC_GET_LOC_BY_LOCID";
  public readonly LOC_PROC_UPDATE_LOC_BY_LOCID = "LOC_PROC_UPDATE_LOC_BY_LOCID";
  public readonly GET_USER_CURRENT_LOCATION = "GET_USER_CURRENT_LOCATION";
  public readonly LIST_ALL_CITIES = "LIST_ALL_CITIES";
  public readonly ADD_LOC_BULK_ORG = "ADD_LOC_BULK_ORG";
  public readonly ADD_BULK_ENTITY = "ADD_BULK_ENTITY";
  public readonly ADD_LOC_BULK = "ADD_LOC_BULK";

  // PROCESS NAMES FOR Notification
  public readonly NOTIFICATION_PROC_LIST = "NOTIFICATION_PROC_LIST";
  public readonly FIREBASE_PROC_GET_CUSTOM_TOKEN =
    "FIREBASE_PROC_GET_CUSTOM_TOKEN";
  public readonly NOTIFICATION_PROC_UPDATE = "NOTIFICATION_PROC_UPDATE";
  // ------------------------------------------

  // PROCESS NAMES FOR Attendance
  public readonly GET_ACTIVE_STATS = "GET_ACTIVE_STATS";
  public readonly GET_EVENTS_COUNTS = "GET_EVENTS_COUNTS";
  public readonly VIEW_ORG_ATTENDANCE_LOG = "VIEW_ORG_ATTENDANCE_LOG";
  public readonly GET_EVENTS_DETAILS = "GET_EVENTS_DETAILS";
  public readonly GET_ATTENDENCE = "GET_ATTENDENCE";

  // PROCESS NAMES FOR Client/Vendor
  public readonly ADD_CLIENT_VENDOR = "ADD_CLIENT_VENDOR";
  public readonly UPDATE_CLIENT_VENDOR = "UPDATE_CLIENT_VENDOR";
  public readonly LIST_ALL_CV_ORG = "LIST_ALL_CV_ORG";
  public readonly DELETE_CLIENT_VENDOR = "DELETE_CLIENT_VENDOR";
  public readonly LIST_CV_BY_ID = "LIST_CV_BY_ID";

  // PROCESS SOCIAL LOGIN AND SIGNUP
  public readonly SOCIAL_SIGNUP = "SOCIAL_SIGNUP";
  public readonly SOCIAL_LOGIN = "SOCIAL_LOGIN";
  public readonly MOBILE_ACCOUNT_VERIFICATION = "MOBILE_ACCOUNT_VERIFICATION";

  // PROCESS ROUTES
  public readonly UL_PROC_GET_ROUTE_VIEW = "UL_PROC_GET_ROUTE_VIEW";

  // PROCESS REPORT
  public readonly GET_MEMBER_ATTENDANCE_REPORT = "GET_MEMBER_ATTENDANCE_REPORT";
  public readonly GET_MEMBER_ATTENDANCE_REPORT_NEW =
    "GET_MEMBER_ATTENDANCE_REPORT_NEW";
  public readonly GET_TEAM_ATTENDANCE_REPORT = "GET_TEAM_ATTENDANCE_REPORT";
  public readonly SITUATION_REPORT_LIST = "SITUATION_REPORT_LIST";
  public readonly GET_ORG_META = "GET_ORG_META";
  public readonly VIEW_DISTRIBUTOR_ROUTEPLAN = "VIEW_DISTRIBUTOR_ROUTEPLAN";
  public readonly INV_STOCK_STATUS_LIST_DISTRIBUTOR =
    "INV_STOCK_STATUS_LIST_DISTRIBUTOR";
  // PROCESS ROLES
  public readonly GET_MEMBER_MODULE_ACCESS = "GET_MEMBER_MODULE_ACCESS";
  public readonly UPDATE_MODULE_ACCESS = "UPDATE_MODULE_ACCESS";
  public readonly GET_MODULES_BY_APP = "GET_MODULES_BY_APP";
  // PROCESS DOCTOR
  public readonly ADD_DOCTOR = "ADD_DOCTOR";
  public readonly UPDATE_DOCTOR = "UPDATE_DOCTOR";
  public readonly LIST_DOCTOR_GRADING = "LIST_DOCTOR_GRADING";
  public readonly LIST_DOCTOR_QUALIFICATION = "LIST_DOCTOR_QUALIFICATION";
  public readonly LIST_DOCTOR_SPECIALITIES = "LIST_DOCTOR_SPECIALITIES";
  public readonly LIST_ALL_DOCTORS = "LIST_ALL_DOCTORS";
  public readonly LIST_DOCTOR_BY_ID = "LIST_DOCTOR_BY_ID";
  public readonly DELETE_DOCTOR = "DELETE_DOCTOR";
  public readonly DOC_PROC_DELETE_LOC = "DOC_PROC_DELETE_LOC";
  public readonly DOC_PROC_SET_LOC = "DOC_PROC_SET_LOC";
  public readonly DOC_PROC_GET_LOC = "DOC_PROC_GET_LOC";
  public readonly ADD_DOCTOR_TIMINGS = "ADD_DOCTOR_TIMINGS";
  public readonly UPDATE_DOCTOR_TIMINGS = "UPDATE_DOCTOR_TIMINGS";
  public readonly DELETE_DOCTOR_TIMINGS = "DELETE_DOCTOR_TIMINGS";
  public readonly DOC_PROC_LIST_LOCS_BY_DAY = "DOC_PROC_LIST_LOCS_BY_DAY";
  // PROCESS DISTRIBUTOR
  public readonly DISTRIBUTOR_PROC_ADD = "DISTRIBUTOR_PROC_ADD";
  public readonly DISTRIBUTOR_PROC_LIST = "DISTRIBUTOR_PROC_LIST";
  public readonly DISTRIBUTOR_PROC_LIST_BY_ID = "DISTRIBUTOR_PROC_LIST_BY_ID";
  public readonly DISTRIBUTOR_PROC_DELETE = "DISTRIBUTOR_PROC_DELETE";
  public readonly DISTRIBUTOR_PROC_UPDATE = "DISTRIBUTOR_PROC_UPDATE";
  public readonly LOC_PROC_GET_LOCS_BY_FTYPE = "LOC_PROC_GET_LOCS_BY_FTYPE";
  // PROCESS DEALER
  public readonly DEALER_PROC_ADD = "DEALER_PROC_ADD";
  public readonly DEALER_PROC_LIST = "DEALER_PROC_LIST";
  public readonly DEALER_PROC_LIST_BY_ID = "DEALER_PROC_LIST_BY_ID";
  public readonly DEALER_PROC_DELETE = "DEALER_PROC_DELETE";
  public readonly DEALER_PROC_UPDATE = "DEALER_PROC_UPDATE";
  // PROCESS VISIT
  public readonly ADD_VISIT = "ADD_VISIT";
  public readonly ADD_AGENDA = "ADD_AGENDA";
  public readonly GET_VISIT_DETAILS_BY_ID = "GET_VISIT_DETAILS_BY_ID";
  public readonly UPDATE_SCHEDULE = "UPDATE_SCHEDULE";
  public readonly UPDATE_AGENDA = "UPDATE_AGENDA";
  public readonly DELETE_AGENDA = "DELETE_AGENDA";
  public readonly UPDATE_ATTENDEE = "UPDATE_ATTENDEE";
  public readonly DELETE_ATTENDEES = "DELETE_ATTENDEES";
  public readonly ADD_ATTENDEES = "ADD_ATTENDEES";
  public readonly UPDATE_VISIT_DOCTOR_LOC = "UPDATE_VISIT_DOCTOR_LOC";
  public readonly VIEW_ALL_ORGANIZATION_VISIT = "VIEW_ALL_ORGANIZATION_VISIT";
  public readonly DELETE_VISIT = "DELETE_VISIT";
  public readonly ADD_NOTE = "ADD_NOTE";

  /* TEMPLATE */
  public readonly ADD_TEMPLATE = "ADD_TEMPLATE";
  public readonly UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
  public readonly DELETE_TEMPLATE = "DELETE_TEMPLATE";
  public readonly LIST_TEMPLATE = "LIST_TEMPLATE";

  /* GROUPS */
  public readonly ADD_GROUP = "ADD_GROUP";
  public readonly UPDATE_GROUP = "UPDATE_GROUP";
  public readonly DELETE_GROUP = "DELETE_GROUP";
  public readonly LIST_GROUP = "LIST_GROUP";
  public readonly DETAIL_GROUP = "DETAIL_GROUP";
  public readonly ADD_GROUP_CONTACTS = "ADD_GROUP_CONTACTS";

  /* CAMPAIGNS */
  public readonly ADD_CAMPAIGN = "ADD_CAMPAIGN";
  public readonly UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";
  public readonly DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
  public readonly LIST_CAMPAIGN = "LIST_CAMPAIGN";
  public readonly DETAIL_CAMPAIGN = "DETAIL_CAMPAIGN";
  public readonly GET_COMPAIGN_REPORT = "GET_COMPAIGN_REPORT";
  public readonly APPROVE_COMPAIGN = "APPROVE_COMPAIGN";
  public readonly REJECT_COMPAIGN = "REJECT_COMPAIGN";
  /* PLATEFORM TYPE */
  public readonly PLATFORM_TYPE= "1";

  /* STATUS CODES */
  public readonly SUCCESS_CODE = 1;

  /* USER TYPE */
  public readonly ADMIN = 1;
  public readonly SUBS = 0;

  // MODULE ID
  public readonly DASHBOARD_MODULE_ID = "1";
  public readonly ORGANIZATION_MODULE_ID = "2";
  public readonly PEOPLE_MODULE_ID = "3";
  public readonly CLIENT_VENDOR_MODULE_ID = "4";
  public readonly TEAMS_MODULE_ID = "5";
  public readonly SHIFT_MODULE_ID = "6";
  public readonly PLACES_MODULE_ID = "7";
  public readonly TEAM_VIEW_MODULE_ID = "8";
  public readonly REPORTS_MODULE_ID = "9";
  public readonly ROUTES_VIEW_MODULE_ID = "10";
  public readonly SITREP_MODULE_ID = "11";
  public readonly DOCTOR_MODULE_ID = "13";
  public readonly DISTRIBUTOR_MODULE_ID = "14";
  public readonly VISIT_MODULE_ID = "15";
  public readonly INVENTORY_MODULE_ID = "16";
  public readonly PRODUCT_MODULE_ID = "17";
  public readonly SURVEY_MODULE_ID = "18";
  public readonly SMS_MODULE_ID = "19";
  public readonly ADDON_MODULE_ID = "21";
  public readonly DEALER_MODULE_ID = "22";
  public readonly ORDERS_MODULE_ID = "23";
  public readonly CUSTOMER_MODULE_ID = "27";
  public readonly ROUTE_MODULE_ID = "28";
  public readonly PROJECT_MODULE_ID = "29";
  public readonly COMPLAINTS_MODULE_ID = "30";
  public readonly CRM_MODULE_ID = "31";
  public readonly LEADS_MODULE_ID = "32";
  public readonly QUOTATIONS_MODULE_ID = "33";
  public readonly FIELD_FORM_MODULE_ID = "34";
  public readonly EXPENSE_MODULE_ID = "35";

  public readonly LEAVE_MODULE_ID = "36";
  public readonly LEAVE_CONFIG_MODULE_ID = "37";
  public readonly LEAVE_APPLY_MODULE_ID = "38";

  /* IMAGE URL */
  public readonly CALENDAR = "assets/img/custom/Calendar.jpg";
  public readonly GOOGLE_LOGO = " assets/img/custom/google-icon.jpg";
  public readonly LOGO = "assets/img/logo/logo.png";
  public readonly ICON1 = "assets/img/app/icon1.jpg";
  public readonly ICON2 = "assets/img/app/icon2.jpg";
  public readonly ICON3 = "assets/img/app/icon3.jpg";
  public readonly ICON4 = "assets/img/app/icon4.jpg";
  public readonly ICON5 = "assets/img/app/icon5.jpg";
  public readonly ICON6 = "assets/img/app/icon6.jpg";
  public readonly LOGIN_LOGO = "assets/brand-logo-white.png";
  public readonly IMAGE_NO_ATTACHMENT = "assets/img/app/noimage1.jpg";
  public readonly SMALL_LOGO = "assets/img/logo/small_logo.png";
  public readonly EDIT_ICON = "assets/img/custom/edit-icon.png";
  public readonly REPORT_ICON = "assets/img/custom/report-icon.png";
  public readonly MARKER = "assets/img/logo/red.png";
  public readonly LOC_MAKER1 = "assets/img/PIN/dark-blue.png";
  public readonly LOC_MAKER2 = "assets/img/PIN/blue.png";
  public readonly LOC_MAKER3 = "assets/img/PIN/green.png";
  public readonly LOC_MAKER4 = "assets/img/PIN/red.png";
  public readonly LOC_MAKER5 = "assets/img/PIN/orange.png";
  public readonly LOC_YELLOW_PIN = "assets/img/logo/yellow.png";
  public readonly LOC_RED_PIN = "assets/img/logo/red.png";
  public readonly LOC_GREEN_PIN = "assets/img/logo/green.png";
  public readonly LOC_PIN = "assets/img/PIN/red-pin.png";
  public readonly MAP_ICON = "assets/img/custom/map-icon.png";
  public readonly CAM_ICON = "assets/img/custom/camera.png";
  public readonly MEM_ICON = "assets/img/location/mem2.png";
  public readonly BUILDING = "assets/img/custom/building.png";
  public readonly CAM_FEED = "assets/img/custom/camera_feed.gif";

  // Doctor PINS
  public readonly MON_PIN = "assets/img/PIN/Mon.png";
  public readonly TUES_PIN = "assets/img/PIN/Tues.png";
  public readonly WED_PIN = "assets/img/PIN/Wed.png";
  public readonly THURS_PIN = "assets/img/PIN/Thurs.png";
  public readonly FRI_PIN = "assets/img/PIN/Fri.png";
  public readonly SAT_PIN = "assets/img/PIN/Sat.png";
  public readonly UPLOAD_ICON = "assets/img/PIN/add-bulk.png";

  // PRODUCT
  public readonly INV_PRODUCT_ADD = "INV_PRODUCT_ADD";
  public readonly INV_PRODUCT_LIST = "INV_PRODUCT_LIST";
  public readonly INV_PRODUCT_DELETE = "INV_PRODUCT_DELETE";
  public readonly INV_CATEGORY_UPDATE = "INV_CATEGORY_UPDATE";
  public readonly INV_PRODUCT_UPDATE = "INV_PRODUCT_UPDATE";
  public readonly INV_CATEGORY_ADD = "INV_CATEGORY_ADD";
  public readonly INV_CATEGORY_LIST = "INV_CATEGORY_LIST";
  public readonly INV_CATEGORY_DELETE = "INV_CATEGORY_DELETE";
  public readonly INV_UOM_LIST = "INV_UOM_LIST";
  public readonly REPORTED_INV_ENTRY = "REPORTED_INV_ENTRY";
  public readonly ADD_REPORT_INV_COMMENT = "ADD_REPORT_INV_COMMENT";
  public readonly UPDATE_REPORT_INV_COMMENT = "UPDATE_REPORT_INV_COMMENT";
  public readonly DELETE_REPORT_INV_COMMENT = "DELETE_REPORT_INV_COMMENT";
  public readonly REPORTED_INV_LIST = "REPORTED_INV_LIST";
  // Pachage
  public readonly INV_PACKAGING_ADD = "INV_PACKAGING_ADD";
  public readonly INV_PACKAGING_LIST = "INV_PACKAGING_LIST";
  public readonly INV_PACKAGING_UPDATE = "INV_PACKAGING_UPDATE";
  public readonly INV_PACKAGING_DELETE = "INV_PACKAGING_DELETE";
  //BATCH
  public readonly INV_BATCH_ADD = "INV_BATCH_ADD";
  public readonly INV_BATCH_ADD_SKU = "INV_BATCH_ADD_SKU";
  public readonly INV_BATCH_LIST = "INV_BATCH_LIST";
  public readonly INV_BATCH_UPDATE = "INV_BATCH_UPDATE";
  public readonly INV_BATCH_DELETE = "INV_BATCH_DELETE";
  public readonly INV_PRODUCT_SKU_BATCH_DETAIL = "INV_PRODUCT_SKU_BATCH_DETAIL";
  public readonly TOTAL_ENTITIES = "TOTAL_ENTITIES";

  //SKU
  public readonly INV_PRODUCT_ADD_SKU = "INV_PRODUCT_ADD_SKU";
  public readonly INV_PRODUCT_UPDATE_SKU = "INV_PRODUCT_UPDATE_SKU";
  public readonly INV_PRODUCT_SKU_LIST = "INV_PRODUCT_SKU_LIST";
  public readonly INV_BATCH_UPDATE_SKU = "INV_BATCH_UPDATE_SKU";
  public readonly INV_BATCH_DELETE_SKU = "INV_BATCH_DELETE_SKU";
  public readonly INV_STOCK_MOVEMENT_IN = "INV_STOCK_MOVEMENT_IN";
  public readonly INV_STOCK_MOVEMENT_OUT = "INV_STOCK_MOVEMENT_OUT";
  public readonly INV_PRODUCT_DELETE_SKU = "INV_PRODUCT_DELETE_SKU";
  public readonly INV_PRODUCT_INVENTORY_BULK = "INV_PRODUCT_INVENTORY_BULK";

  // Stock
  public readonly INV_STOCK_MOVEMENT_ADD = "INV_STOCK_MOVEMENT_ADD";
  public readonly INV_STOCK_MOVEMENT_LIST = "INV_STOCK_MOVEMENT_LIST";
  public readonly INV_STOCK_MOVEMENT_DELETE = "INV_STOCK_MOVEMENT_DELETE";
  public readonly INV_STOCK_STATUS_LIST = "INV_STOCK_STATUS_LIST";
  // Meta
  public readonly INV_META_ADD = "INV_META_ADD";
  public readonly INV_META_LIST = "INV_META_LIST";
  public readonly INV_META_UPDATE = "INV_META_UPDATE";
  public readonly INV_META_DELETE = "INV_META_DELETE";
  public readonly ADD_LU_META = "ADD_LU_META";
  public readonly ALL_LU_META = "ALL_LU_META";

  // UOM
  public readonly INV_UOM_ADD = "INV_UOM_ADD";
  public readonly INV_UOM_DELETE = "INV_UOM_DELETE";

  // Media
  public readonly INV_MEDIA_ADD = "INV_MEDIA_ADD";
  public readonly INV_MEDIA_LIST = "INV_MEDIA_LIST";
  public readonly INV_MEDIA_DELETE = "INV_MEDIA_DELETE";
  public readonly INV_UOM_UPDATE = "INV_UOM_UPDATE";

  //Chat
  public readonly UPLOAD_FIREBASE_MEDIA = "UPLOAD_FIREBASE_MEDIA";

  public readonly DISTRICT_LIST = "DISTRICT_LIST";
  public readonly UC_LIST = "UC_LIST";
  public readonly VILLAGE_LIST = "VILLAGE_LIST";
  public readonly TALUKA_LIST = "TALUKA_LIST";

  /* SURVEY */
  public readonly ADD_SURVEY = "ADD_SURVEY";
  public readonly LIST_SERVEY = "LIST_SERVEY";
  public readonly DELETE_SURVEY = "DELETE_SURVEY";
  public readonly UPDATE_SURVEY = "UPDATE_SURVEY";
  public readonly LIST_SURVEY_TEMPLATE = "LIST_SURVEY_TEMPLATE";
  public readonly LIST_SERVEY_BY_ID = "LIST_SERVEY_BY_ID";
  public readonly SURVEY_REPORT_DASHBOARD = "SURVEY_REPORT_DASHBOARD";
  public readonly SURVEY_REPORT_IN_ALL = "SURVEY_REPORT_IN_ALL";
  public readonly SURVEY_REPORT_IN_INDIVISUAL = "SURVEY_REPORT_IN_INDIVISUAL";
  public readonly SERVEY_REPORT = "SERVEY_REPORT";
  public readonly DELETE_SURVEY_QUESTION_BY_ID = "DELETE_SURVEY_QUESTION_BY_ID";
  public readonly LIST_ANSWER_BY_SERVEY_ID = "LIST_ANSWER_BY_SERVEY_ID";
  public readonly LIST_SURVEY_QUESTION_BY_SURVEY_ID =
    "LIST_SURVEY_QUESTION_BY_SURVEY_ID";
  public readonly ADD_SURVEY_QUESTION = "ADD_SURVEY_QUESTION";
  public readonly UPDATE_SURVEY_QUESTION_BY_ID = "UPDATE_SURVEY_QUESTION_BY_ID";

  /*ADDON */
  public readonly DETAIL_ADDON = "DETAIL_ADDON";
  public readonly ENABLE_ADDON = "ENABLE_ADDON";

  //default
  public readonly DEFAULT_USER = "assets/img/users/default-user.jpg";
  public readonly DUMMY_USER = "assets/img/profile/dummy_img.png";
  public readonly PLACEHOLDER_IMAGE = "assets/img/custom/placeholder-image.jpg";
  public readonly PLACEHOLDER_IMAGE_CAPTURE = "assets/img/custom/Capture.png";
  public readonly FILE_PINS = "assets/img/profile/file_pin.jpg";
  /*Order Management */
  public readonly ADD_ORDER = "ADD_ORDER";
  public readonly DELETE_ORDER = "DELETE_ORDER";
  public readonly UPDATE_ORDER = "UPDATE_ORDER";
  public readonly UPDATE_PRODUCT = "UPDATE_PRODUCT";
  public readonly DELETE_PRODUCT = "DELETE_PRODUCT";
  public readonly UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
  public readonly LIST_ORDER = "LIST_ORDER";
  public readonly PUSH_ORDER_DETAILS = "PUSH_ORDER_DETAILS";
  public readonly LIST_ORDERS_WEB = "LIST_ORDERS_WEB";
  public readonly ADD_ORDER_DOCUMENTS = "ADD_ORDER_DOCUMENTS";
  public readonly ORDER_REPORT = "ORDER_REPORT";
  public readonly LIST_CUSTOMER_ENTITIES = "LIST_CUSTOMER_ENTITIES";
  public readonly LIST_MY_ORDERS = "LIST_MY_ORDERS";
  public readonly LIST_MY_DISTRIBUTOR_ORDERS = "LIST_MY_DISTRIBUTOR_ORDERS";
  ;
  // PROCESS Leave
  public readonly ADD_LEAVE = "ADD_LEAVE";
  public readonly UPDATE_LEAVE = "UPDATE_LEAVE";
  public readonly DELETE_LEAVE = "DELETE_LEAVE";
  public readonly LIST_LEAVE = "LIST_LEAVE";
  // PROCESS HOLIDAY
  public readonly ADD_HOLIDAY = "ADD_HOLIDAY";
  public readonly UPDATE_HOLIDAY = "UPDATE_HOLIDAY";
  public readonly LIST_HOLIDAYS = "LIST_HOLIDAYS";
  public readonly DELETE_HOLIDAY = "DELETE_HOLIDAY";

  //PROCESS APPLY LEAVE
  public readonly ADD_APPLY_LEAVE = "ADD_APPLY_LEAVE";
  public readonly UPDATE_APPLY_LEAVE = "UPDATE_APPLY_LEAVE";
  public readonly LIST_APPLY_LEAVE = "LIST_APPLY_LEAVE";
  public readonly DELETE_APPLY_LEAVE = "DELETE_APPLY_LEAVE";
  public readonly UPDATE_APPLY_LEAVE_STATUS = "UPDATE_APPLY_LEAVE_STATUS";

  //PROCESS LEAVE COUNTS
  public readonly LEAVE_COUNT = "LEAVE_COUNT";

  //PROCESS LIST LEAVE MEMBERS FOR SUPERVISOR
  public readonly LIST_LEAVE_MEMBERS_FOR_SUPERVISOR = "LIST_LEAVE_MEMBERS_FOR_SUPERVISOR";

  //PROCESS LIST LEAVE MEMBERS FOR OFFICERS
  public readonly LIST_LEAVE_MEMBERS_FOR_TIME_OFFICER = "LIST_LEAVE_MEMBERS_FOR_TIME_OFFICER"
  //PROCESS REPORT LEAVE MEMBERS 
  public readonly REPORT_MEM_LEAVE = "REPORT_MEM_LEAVE"
  // PROCESS VISIT
  public readonly ADD_ROUTEPLAN = "ADD_ROUTEPLAN";
  public readonly UPDATE_ROUTEPLAN_SUB = "UPDATE_ROUTEPLAN_SUB";
  public readonly CALL_ADD_AGENDA = "ADD_AGENDA";
  public readonly GET_ROUTEPLAN_DETAILS_BY_ID = "GET_ROUTEPLAN_DETAILS_BY_ID";
  public readonly CALL_VIEW_DOCTOR_BY_LOC_ID = "VIEW_DOCTOR_BY_LOC_ID";
  public readonly CALL_UPDATE_SCHEDULE = "UPDATE_SCHEDULE";
  public readonly CALL_UPDATE_AGENDA = "UPDATE_AGENDA";
  public readonly CALL_DELETE_AGENDA = "DELETE_AGENDA";
  public readonly CALL_UPDATE_ATTENDEE = "UPDATE_ATTENDEE";
  public readonly CALL_DELETE_ATTENDEES = "DELETE_ATTENDEES";
  public readonly CALL_ADD_ATTENDEES = "ADD_ATTENDEES";
  public readonly CALL_UPDATE_VISIT_DOCTOR_LOC = "UPDATE_VISIT_DOCTOR_LOC";
  public readonly VIEW_ALL_ORGANIZATION_ROUTEPLAN =
    "VIEW_ALL_ORGANIZATION_ROUTEPLAN";
  public readonly DELETE_ROUTEPLAN = "DELETE_ROUTEPLAN";
  public readonly CALL_ADD_NOTE = "ADD_NOTE";
  public readonly FF_DAILY_CALL_REPORT = "FF_DAILY_CALL_REPORT";
  public readonly FF_MONTHLY_CALL_REPORT = "FF_MONTHLY_CALL_REPORT";
  public readonly FF_MONTHLY_CALL_SUMMARY_REPORT =
    "FF_MONTHLY_CALL_SUMMARY_REPORT";
  public readonly FF_DAILY_UP_COUNTRY_REPORT = "FF_DAILY_UP_COUNTRY_REPORT";
  public readonly FF_SUMMARIZED_TOURING_REPORT = "FF_SUMMARIZED_TOURING_REPORT";
  public readonly FF_DAILY_TOURING_SUMMARY_REPORT =
    "FF_DAILY_TOURING_SUMMARY_REPORT";
  public readonly FF_DAILY_CALL_REPORT_NEWCUSTOMERS =
    "FF_DAILY_CALL_REPORT_NEWCUSTOMERS";
  // PROCESS APPROVAL
  public readonly APPROVE_MEMBER_VISIT = "APPROVE_MEMBER_VISIT";
  public readonly LIST_SUPERVISOR_MEMBERS = "LIST_SUPERVISOR_MEMBERS";
  public readonly REJECT_MEMBER_VISIT = "REJECT_MEMBER_VISIT";

  /*  PROCESSES Complaints*/
  public readonly ADD_COMPLAINT = "ADD_COMPLAINT";
  public readonly UPDATE_COMPLAINT = "UPDATE_COMPLAINT";
  public readonly DELETE_COMPLAINT = "DELETE_COMPLAINT";
  public readonly DETAIL_COMPLAINT = "DETAIL_COMPLAINT";
  public readonly LIST_COMPLAINT = "LIST_COMPLAINT";
  public readonly ATTACH_COMPLAINT_MEDIA = "ATTACH_COMPLAINT_MEDIA";
  public readonly LIST_COMPLAINT_MEDIA = "LIST_COMPLAINT_MEDIA";
  public readonly DETACH_COMPLAINT_MEDIA = "DETACH_COMPLAINT_MEDIA";
  public readonly ADD_COMMENT = "ADD_COMMENT";
  public readonly UPDATE_COMMENT = "UPDATE_COMMENT";
  public readonly DELETE_COMMENT = "DELETE_COMMENT";
  public readonly LIST_COMPLAIN_COMMENTS = "LIST_COMPLAIN_COMMENTS";
  public readonly UPDATE_COMPLAINT_STATUS = "UPDATE_COMPLAINT_STATUS";
  public readonly LIST_RELATIONS = "LIST_RELATIONS";
  public readonly SEARCH_COMPLAINANT_BY_CNIC = "SEARCH_COMPLAINANT_BY_CNIC";
  public readonly SEARCH_GAURDIAN_BY_CNIC = "SEARCH_GAURDIAN_BY_CNIC";
  public readonly LIST_COMPLAIN_TYPES = "LIST_COMPLAIN_TYPES";
  public readonly LIST_COMPLAINT_CATEGORIES = "LIST_COMPLAINT_CATEGORIES";
  public readonly ADD_TASK_MEDIA = "ADD_TASK_MEDIA";
  public readonly LIST_MODULE = "LIST_MODULE";
  public readonly LIST_SUB_MODULE_BY_PARENT_ID = "LIST_SUB_MODULE_BY_PARENT_ID";
  public readonly LIST_SUB_MODULE = "LIST_SUB_MODULE";

  //	Member Limit
  public readonly ALLOWED_MEMBER_STATS = "ALLOWED_MEMBER_STATS";
  public readonly ORG_MSISDN_CHECK = "ORG_MSISDN_CHECK";

  //	Modules for Metas
  public readonly MODULEID_ORGANIZATION = 1;
  public readonly MODULEID_MEMBER = 2;
  public readonly MODULEID_DASHBOARD = 3;
  public readonly MODULEID_TEAM = 4;
  public readonly MODULEID_POLICY = 5;
  public readonly MODULEID_REPORTS = 6;
  public readonly MODULEID_PACKAGES = 7;
  public readonly MODULEID_CLIENT_VENDOR = 8;
  public readonly MODULEID_PLACES = 9;
  public readonly MODULEID_SITREP = 10;
  public readonly MODULEID_TEAM_VIEW = 11;
  public readonly MODULEID_ROUTE_VIEW = 12;
  public readonly MODULEID_INVENTORY = 13;
  public readonly MODULEID_SURVEY = 18;
  public readonly MODULEID_CAMPAIGN = 19;
  //PROCESS GROUP
  public readonly ADD_CUST_GROUP = "ADD_CUST_GROUP";
  public readonly LIST_CUST_GROUP = "LIST_CUST_GROUP";
  public readonly UPDATE_CUST_GROUP = "UPDATE_CUST_GROUP";
  public readonly DELETE_CUST_GROUP = "DELETE_CUST_GROUP";
  public readonly ADD_CUST_GROUP_MEM = "ADD_CUST_GROUP_MEM";
  public readonly DELETE_CUST_GROUP_MEM = "DELETE_CUST_GROUP_MEM";
  public readonly LIST_CUST_GROUP_MEM = "LIST_CUST_GROUP_MEM";
  //PROCESS DISTRIBUTION
  public readonly ADD_ENTITY_CATEGORY = "ADD_ENTITY_CATEGORY";
  public readonly LIST_ENTITY_CATEGORIES = "LIST_ENTITY_CATEGORIES";
  public readonly UPDATE_ENTITY_CATEGORY = "UPDATE_ENTITY_CATEGORY";
  public readonly DELETE_ENTITY_CATEGORY = "DELETE_ENTITY_CATEGORY";
  public readonly ADD_DISCOUNT = "ADD_DISCOUNT";
  public readonly LIST_DISCOUNT = "LIST_DISCOUNT";
  public readonly UPDATE_DISCOUNT = "UPDATE_DISCOUNT";
  public readonly DELETE_DISCOUNT = "DELETE_DISCOUNT";
  //PROCESS ENTITY
  public readonly ADD_ENTITY = "ADD_ENTITY";
  public readonly UPDATE_ENTITY = "UPDATE_ENTITY";
  public readonly LIST_ENTITY = "LIST_ENTITY";
  public readonly DELETE_ENTITY = "DELETE_ENTITY";
  public readonly LIST_ENTITY_BY_ID = "LIST_ENTITY_BY_ID";
  public readonly ENTITY_META_ADD = "ENTITY_META_ADD";
  public readonly ENTITY_META_UPDATE = "ENTITY_META_UPDATE";
  public readonly ENTITY_META_DELETE = "ENTITY_META_DELETE";

  //PROCESS BULK
  public readonly ADD_BULK_CUSTOMER = "ADD_BULK_CUSTOMER";
  public readonly ADD_BULK_LOCATION = "ADD_BULK_LOCATION";

  //PROCESS PROJECT
  public readonly ADD_PROJECT = "ADD_PROJECT";
  public readonly UPDATE_PROJECT = "UPDATE_PROJECT";
  public readonly DELETE_PROJECT = "DELETE_PROJECT";
  public readonly LIST_PROJECT = "LIST_PROJECT";
  public readonly PROJECT_DASHBOARD = "PROJECT_DASHBOARD";
  public readonly REPORT_BY_MEMBER_ID = "REPORT_BY_MEMBER_ID";

  //PROCESS PAKAGE
  public readonly ADD_PACKAGE = "ADD_PACKAGE";
  public readonly UPDATE_PACKAGE = "UPDATE_PACKAGE";
  public readonly DELETE_PACKAGE = "DELETE_PACKAGE";
  public readonly LIST_PACKAGE_DETAIL = "LIST_PACKAGE_DETAIL";
  public readonly LIST_PACKAGES = "LIST_PACKAGES";
  public readonly LIST_PACKAGES_FOR_NGO = "LIST_PACKAGES_FOR_NGO";
  // RElIEF ORGANIZATION
  public readonly ADD_ORG_REL = "ADD_ORG";
  public readonly VIEW_ORG_REL = "VIEW_ORG";
  public readonly USER_ORG = "USER_ORG";
  public readonly EDIT_ORG_REL = "EDIT_ORG";
  public readonly DELETE_ORG_REL = "DELETE_ORG";
  public readonly ALL_INDUSTRIES_REL = "ALL_INDUSTRIES";
  //PROCESS EXPENSE
  public readonly ADD_EXPENSE = "ADD_EXPENSE";
  public readonly UPDATE_EXPENSE = "UPDATE_EXPENSE";
  public readonly DELETE_EXPENSE = "DELETE_EXPENSE";
  public readonly LIST_EXPENSE = "LIST_EXPENSE";
  public readonly DETAIL_EXPENSE = "DETAIL_EXPENSE";
  public readonly ADD_CATEGORY = "ADD_CATEGORY";
  public readonly LIST_CATEGORY = "LIST_CATEGORY";
  public readonly UPDATE_CATEGORY = "UPDATE_CATEGORY";
  public readonly DELETE_CATEGPRY = "DELETE_CATEGPRY";
  public readonly LIST_USER_DISTANCE_COVERED = "LIST_USER_DISTANCE_COVERED";
  public readonly LIST_EXPENSE_REPORT = "LIST_EXPENSE_REPORT";
  public readonly ADD_EX_STATUS = "ADD_EX_STATUS";
  public readonly UPDATE_EX_STATUS = "UPDATE_EX_STATUS";
  public readonly DELETE_EX_STATUS = "DELETE_EX_STATUS";
  public readonly LIST_EX_STATUS = "LIST_EX_STATUS";
  public readonly ADD_EXPENSE_MEDIA = "ADD_EXPENSE_MEDIA";
  public readonly ADD_EX_COMMENT_MEDIA = "ADD_EX_COMMENT_MEDIA";
  public readonly DELETE_EXPENSE_MEDIA = "DELETE_EXPENSE_MEDIA";
  public readonly ADD_EX_COMMENT = "ADD_EX_COMMENT";
  public readonly UPDATE_EX_COMMENT = "UPDATE_EX_COMMENT";
  public readonly LIST_EX_COMMENT = "LIST_EX_COMMENT";
  public readonly DELETE_EX_COMMENT = "DELETE_EX_COMMENT";
  public readonly AUTHORIZE_EXPENSE = "AUTHORIZE_EXPENSE";
  public readonly LIST_EX_COMMENT_MEDIA = "LIST_EX_COMMENT_MEDIA";

  // public readonly ADD_PROJECT = "ADD_PROJECT";
  // public readonly ADD_PROJECT = "ADD_PROJECT";
  public readonly ADD_TASK = "ADD_TASK";
  public readonly UPDATE_TASK = "UPDATE_TASK";
  public readonly DELETE_TASK = "DELETE_TASK";
  public readonly LIST_TASK = "LIST_TASK";
  public readonly LIST_TASK_CATEGORY = "LIST_TASK_CATEGORY";
  public readonly ADD_TASK_CATEGORY = "ADD_TASK_CATEGORY";
  public readonly UPDATE_TASK_CATEGORY = "UPDATE_TASK_CATEGORY";
  public readonly DELETE_TASK_CATEGORY = "DELETE_TASK_CATEGORY";
  public readonly DELETE_PMS_MEDIA = "DELETE_PMS_MEDIA";
  public readonly ADD_TASK_MEMBER = "ADD_TASK_MEMBER";
  public readonly UPDATE_TASK_MEMBER = "UPDATE_TASK_MEMBER";
  public readonly DELETE_TASK_MEMBER = "DELETE_TASK_MEMBER";
  //ADD PROJECT MEMBER
  public readonly ADD_PROJECT_MEMBER = "ADD_PROJECT_MEMBER";
  public readonly DELETE_PROJECT_MEMBER = "DELETE_PROJECT_MEMBER";
  FILE_PIN: any;

  //Location Report
  public readonly LIST_USER_LOCALITY = "LIST_USER_LOCALITY";
  //Bulk

  public readonly ADD_BULK_ROUTEPLAN = "ADD_BULK_ROUTEPLAN";
  //CRM
  public readonly ADD_LEAD = "ADD_LEAD";
  public readonly UPDATE_LEAD = "UPDATE_LEAD";
  public readonly LIST_LEAD_BY_ID = "LIST_LEAD_BY_ID";
  public readonly LIST_LEADS = "LIST_LEADS";
  public readonly DELETE_LEAD = "DELETE_LEAD";
  public readonly ADD_QUOTATION = "ADD_QUOTATION";
  public readonly UPDATE_QUOTATION = "UPDATE_QUOTATION";
  public readonly LIST_QUOTATION = "LIST_QUOTATION";
  public readonly LIST_QUOTATION_BY_ID = "LIST_QUOTATION_BY_ID";
  public readonly DELETE_QUOTATION = "DELETE_QUOTATION";
  public readonly ADD_STATUS = "ADD_STATUS";
  public readonly UPDATE_STATUS = "UPDATE_STATUS";
  public readonly LIST_STATUS = "LIST_STATUS";
  public readonly DELETE_STATUS = "DELETE_STATUS";
  public readonly LIST_COUNT_ALL = "LIST_COUNT_ALL";
  public readonly LIST_LEADS_BY_STATUS = "LIST_LEADS_BY_STATUS";
  public readonly DETAIL_LEAD = "DETAIL_LEAD";
  public readonly UPDATE_USER_DEFINE_STATUS_IN_LEAD =
    "UPDATE_USER_DEFINE_STATUS_IN_LEAD";
  public readonly ADD_QUOTATION_PAYMENT_TERM = "ADD_QUOTATION_PAYMENT_TERM";
  public readonly UPDATE_QUOTATION_PAYMENT_TERM =
    "UPDATE_QUOTATION_PAYMENT_TERM";
  public readonly DELETE_QUOTATION_PAYMENT_TERM =
    "DELETE_QUOTATION_PAYMENT_TERM";
  public readonly LIST_QUOTATION_PAYMENT_TERM = "LIST_QUOTATION_PAYMENT_TERM";
  public readonly ADD_QUOTATION_PRODUCT = "ADD_QUOTATION_PRODUCT";
  public readonly UPDATE_QUOTATION_PRODUCT = "UPDATE_QUOTATION_PRODUCT";
  public readonly DELETE_QUOTATION_PRODUCT = "DELETE_QUOTATION_PRODUCT";
  public readonly UPDATE_QUOTATION_STATUS = "UPDATE_QUOTATION_STATUS";
  public readonly LIST_OF_LEADS = "LIST_OF_LEADS";

  //FORM
  public readonly ADD_GENERAL_STATUS = "ADD_GENERAL_STATUS";
  public readonly UPDATE_GENERAL_STATUS = "UPDATE_GENERAL_STATUS";
  public readonly DELETE_GENERAL_STATUS = "DELETE_GENERAL_STATUS";
  public readonly LIST_GENERAL_STATUS = "LIST_GENERAL_STATUS";
  public readonly ADD_FORM = "ADD_FORM";
  public readonly UPDATE_FORM = "UPDATE_FORM";
  public readonly DELETE_FORM = "DELETE_FORM";
  public readonly LIST_FORM = "LIST_FORM";
  public readonly ADD_FORM_SECTION = "ADD_FORM_SECTION";
  public readonly UPDATE_FORM_SECTION = "UPDATE_FORM_SECTION";
  public readonly DELETE_FORM_SECTION = "DELETE_FORM_SECTION";
  public readonly LIST_FORM_SECTION = "LIST_FORM_SECTION";
  public readonly ADD_SECTION_QUESTION = "ADD_SECTION_QUESTION";
  public readonly UPDATE_SECTION_QUESTION = "UPDATE_SECTION_QUESTION";
  public readonly DELETE_SECTION_QUESTION = "DELETE_SECTION_QUESTION";
  public readonly LIST_SECTION_QUESTION = "LIST_SECTION_QUESTION";
  public readonly ADD_FORM_STATUS = "ADD_FORM_STATUS";
  public readonly DELETE_FORM_STATUS = "DELETE_FORM_STATUS";
  public readonly LIST_FORM_STATUS = "LIST_FORM_STATUS";
  public readonly ADD_FORM_ACCESS = "ADD_FORM_ACCESS";
  public readonly DELETE_FORM_ACCESS = "DELETE_FORM_ACCESS";
  public readonly LIST_FORM_SUBMIT = "LIST_FORM_SUBMIT";
  public readonly ADD_FORM_COMMENT = "ADD_FORM_COMMENT";
  public readonly UPDATE_FORM_COMMENT = "UPDATE_FORM_COMMENT";
  public readonly DELETE_FORM_COMMENT = "DELETE_FORM_COMMENT";
  public readonly LIST_RESPONSE_TO_MEMBERS = "LIST_RESPONSE_TO_MEMBERS";



  // DASHBOARD

  public readonly TRANSACTION_STATS = "TRANSACTION_STATS";
  public readonly LIST_TRANSACTIONS = "LIST_TRANSACTIONS";


  // ITEM

  public readonly LIST_ITEMS = "LIST_ITEMS";

  // //REPORT
  // public readonly LIST_ALL_ORG_MEMBERS = "LIST_ALL_ORG_MEMBERS";
  // public readonly LIST_TRANSACTIONS = "LIST_TRANSACTIONS";
  // public readonly VIEW_ORG_TEAMS = "VIEW_ORG_TEAMS";


}
